export const getProjectContainerScope = (projectId: number | string) => `project-${projectId}`;
